
import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { Receiving } from '../receiving';
import { ReceivingService } from '../receiving.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SettingsService } from '../../../shared/services/settings.service';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Branch } from '../../accounting/branch';
import { ReportService } from '../../../shared/services/report.service';
import { DateRangeDialogComponent } from '../../../shared/dialogs/date-range-dialog/date-range-dialog.component';
import { BranchService } from '../../accounting/branches/branch.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-receiving-list',
  templateUrl: './receiving-list.component.html',
  styleUrls: ['./receiving-list.component.scss'],
  providers: [ReportService]
})
export class ReceivingListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Receiving[];
  subscription: Subscription = new Subscription();
  checked: boolean = false;
  totalMetersValue: number = 0;
  totalWeightValue: number = 0;

  columns: ITdDataTableColumn[] = [
    { name: 'actual_arrival_date', label: 'Arrival Date' },
    { name: 'pieces', label: 'Pieces' },
    //{ name: 'quantity', label: 'QTY (M)' },
    { name: 'actual_length', label: 'Actual QTY (M)' },
    //{ name: 'weight', label: 'Weight (kg)' },
    { name: 'actual_weight', label: 'Actual Weight (kg)' },
    { name: 'status', label: 'Status' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  allBranches: Branch[] = [];
  branch_id_filter: number = 0;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _receivingService: ReceivingService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _branchService: BranchService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    private _reportService: ReportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._receivingService
      .getReceivings()
      .subscribe((recevings: Receiving[]) => {
        this.data = recevings.filter((rcv: Receiving) => { return this._authService.getUserBranches().some((b: Branch) => { return b.code == rcv['requesting_branch_code'] }) });;
        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        this.selectedRows = this.filteredData;
        this.filter();
        this.totalMetersValue = this.data.reduce((acc, el) => acc + +el.qty, 0);
        this.totalWeightValue = this.data.reduce((acc, el) => acc + +el.weight, 0);

        this._loadingService.resolve('loading');

      });

    this._branchService.getBranches().subscribe(
      response => {
        this.allBranches = response;
      }
    );
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('receiving')) {
      this._searchBox.value = this._settingsService.getSearchTerm('receiving');
      this._searchBox.searchClicked();
    }
  }

  total(data: any[], field: string) {
    return (data ? data : []).reduce(function (a, b) { 
      let _a = Number.parseFloat(a);
      let _b = Number.parseFloat(b[field]);

      return (isNaN(_a) ? 0 : _a) + (isNaN(_b) ? 0 : _b);
    }, 0);
  }

  getB2BCode(row: any): string {
    let _sBranch = this.allBranches.find((branch) => { return row['source_branch_id'] == branch['id'] });

    return '(' + ((_sBranch != null) ? _sBranch['code'] : '?') + '-' + row['requesting_branch_code'] + ')';
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  filterBranches($event) {
    console.log(this.branch_id_filter);
  }

  receivingsReport() {
    this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
      result => {
        if (result) {
          this._reportService.getReceivingReportData(result.from, result.to).subscribe(
            reportData => {
              let finalData;

              if (this.branch_id_filter != 0) {
                finalData = reportData.filter((line) => { return line.requesting_branch_id == this.branch_id_filter });
              } else {
                finalData = reportData.filter((line) => { return this._authService.getUserBranches().some(b => { return line.requesting_branch_id == b.id }) });
              }

              // Include only RECEIVED entries
              //finalData = finalData.filter(r => { return r.status == 'RECEIVED' });
              // Remove B2B receivings also from here
              //finalData = finalData.filter(r => { return r.supplier_code != '' });
              
              this._reportService.receivingReport(finalData, result.from, result.to);
            }
          );
        }
      }
    );
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('receiving', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;

    if (this.branch_id_filter != 0) {
      newData = newData.filter((line) => { return line.requesting_branch_id == this.branch_id_filter });
    }
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('receiving'), true, excludedColumns);
    this.filteredTotal = newData.length;

    // Sort by date works differently
    if (this.sortBy == 'actual_arrival_date') {
      newData = newData.sort(
        (d1, d2) => {
          return (new Date(d2[this.sortBy]).getTime() - new Date(d1[this.sortBy]).getTime()) * (this.sortOrder == TdDataTableSortingOrder.Ascending ? 1 : -1)
        }
      );
    } else {
      //newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
      newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    }

    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/receiving/receiving-list/receiving-list.component.ts